import React from "react";
import styles from "./RadioGroup.module.css";

const RadioGroup = ({
  name,
  options,
  value,
  onChange,
  disabled = false,
  className = "",
  "aria-label": ariaLabel,
}) => (
  <div
    className={`${styles.group} ${className}`}
    role="radiogroup"
    aria-label={ariaLabel}
  >
    {options.map(({ label, value: optionValue, disabled: optionDisabled }) => (
      <label className={styles.option} key={optionValue}>
        <input
          type="radio"
          name={name}
          value={optionValue}
          checked={value === optionValue}
          onChange={() => onChange(optionValue)}
          disabled={disabled || optionDisabled}
        />
        <span>{label}</span>
      </label>
    ))}
  </div>
);

export default RadioGroup;
